// eslint-disable-next-line no-restricted-imports
import { SvgIcon, type SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

/**
 * A shield icon with a diagonal slash through it, indicating an unavailable or used credit.
 * Color can be controlled via the `color` prop or `sx={{ color: ... }}`.
 */
export const ShieldWithSlashIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon ref={ref} viewBox="0 0 24 24" {...props}>
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.29583 1.59797L7.79583 2.53547V4.4938C7.79583 4.98963 7.7 5.47713 7.52917 5.92713L8.15833 6.5563C8.45833 5.9188 8.62917 5.21463 8.62917 4.4938V1.9563L5.29583 0.706299L3.12083 1.52297L3.76667 2.1688L5.29583 1.59797ZM1.46667 1.0438L0.875 1.6313L1.9625 2.7188V4.4938C1.9625 6.59797 3.38333 8.56047 5.29583 9.03963C6.0125 8.86047 6.6625 8.47297 7.19167 7.94797L8.5375 9.2938L9.125 8.7063L1.46667 1.0438ZM5.29583 8.17297C3.85833 7.70213 2.79583 6.16463 2.79583 4.4938V3.55213L6.60417 7.36047C6.22917 7.72713 5.78333 8.01463 5.29583 8.17297Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
});

ShieldWithSlashIcon.displayName = "ShieldWithSlashIcon";
